import React from "react";

import Footer from "Components/Common/Footer/Footer";
import Header from "Components/Common/Header/Header";
import CommunitySection from "Components/Community/CommunitySection/CommunitySection";

const Community = () => {
  const eventId = localStorage.getItem("eventId");
  return (
    <>
      <Header moduleName={"community"} />
      <section className="inner_sec">
        <div className="container">
          <div className="page_heading mb-5">
            <h1 className="position-relative pb-4 text-uppercase">community</h1>
          </div>
          <CommunitySection eventId={eventId} />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Community;
